import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PageTemplateTable } from '../../../../directives/page-template-table/page-template-table';
import { StoreRequestSearch } from '../../../../models/api-store/store/store.request.model';
import { StoreService } from '../../../../services/api-store/store/store.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { ProductServiceService } from '../../../../services/api-store/product-service/product-service.service';
import { ProductServiceRequestSearch } from '../../../../models/api-store/product-service/product-service.request.model';
import { MassModifyItem } from '../../../../components/ui/mass-modify/mass-modify-item';
import { environment } from '../../../../../environments/environment';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-storeprenotaeritira',
  templateUrl: './storeprenotaeritira.component.html',
  styleUrls: ['./storeprenotaeritira.component.css']
})
export class StoreprenotaeritiraComponent extends PageTemplateTable implements OnInit, OnDestroy, AfterViewInit {

  searchFilterForm: FormGroup;
  searchFilterOther = {
    searchFilterField_dealerCategory: [],
    searchFilterField_productServiceIds: []
  }
  public dealerCategorySettings: any = {}
  public dealerCategoryList: any[];
  public menuSettings: any;
  public menuList: any;
  public selectedMenu: any;
  public isEmpty: boolean = false;
  public isSearching: boolean = false;
  public fe_url: string = environment.frontendEnv.url;

  constructor(
    private router: Router,
    private storeService: StoreService,
    private productServiceService: ProductServiceService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public modalService: NgbModal
  ) {
    super(modalService);
    this.searchFilterForm = this.fb.group({
      searchOldValue: '',
      searchFilterField: ''
    });
  }

  _dealerCategorySettings() {
    return {
      singleSelection: true,
      text: 'Categoria dealer',
      enableCheckAll: false,
      enableFilterSelectAll: false,
      enableSearchFilter: false,
      searchBy: ['value'],
      classes: 'form-control topic-select',
      showCheckbox: false,
      noDataLabel: 'Nessuna risultato con la ricerca associata',
      searchAutofocus: false,
      lazyLoading: false,
      labelKey: 'value',
      primaryKey: 'value',
      maxHeight: 400
    };
  };

  loadDealerCategoryList() {
    this.storeService.findAllDealerCategories().subscribe(
      (response) => {
        this.dealerCategoryList = [];
        if (response) {
          if (response.dealerCategories != null && typeof response.dealerCategories != typeof undefined) {
            for (let obj of response.dealerCategories) {
              this.dealerCategoryList.push({
                value: obj
              });
            }
          }
        }
      });
  }

  /**
   * Inizializza la tabella
   */
  initTable() {
    const that = this;
    this.initCommon_dtOptions();
    this.dtOptions['columnDefs'] = [
      { orderable: false, targets: 0, width: '5%' },
      { orderable: false, targets: 1, width: '15%' },
      { orderable: false, targets: 2, width: '15%' },
      { orderable: false, targets: 3, width: '15%' },
      { orderable: false, targets: 4, width: '15%' },
      { orderable: false, targets: 5, width: '15%' },
      { orderable: false, targets: 6, width: '10%' },
      { orderable: false, targets: 7, width: '10%' }
    ];
    this.dtOptions['ajax'] = (dataTablesParameters: any, callback) => {
      this.isSearching = true;

      if (dataTablesParameters.start > 0) {
        dataTablesParameters.start = dataTablesParameters.start / this.dimPagina;
      }
      that.numeroPagina = dataTablesParameters.start;
      this.dtOptions.pageLength = this.dimPagina;
      let documentRequestSearch = that.getFilter();
      that.storeService.search(documentRequestSearch).subscribe(
        (response) => {
          if (response) {
            if (response.data.length == 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
            that.setListEntityList(response);
            callback({
              recordsTotal: response.total,
              recordsFiltered: response.total,
              data: []
            });
          } else {
            this.isEmpty = false;
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }
          that.spinner.hide();
          that.isSearching = false;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          that.spinner.hide();
          that.isSearching = false;
        }
      );
    };
    this.menuList = this.lengthMenu;
    this.menuSettings = this.settings;
    this.selectedMenu = this.defaultLength;
    this.selectedMenu = [];
    this.selectedMenu.push(this.defaultLength[0]);
  }

  ngOnInit() {
    this.dealerCategorySettings = this._dealerCategorySettings();
    this.loadDealerCategoryList();
    this.initTable();
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }


  /**
   * Click sulla lente per la ricerca
   */
  clickSearch() {
    this.searchFilterForm.controls.searchOldValue.setValue(this.searchFilterForm.controls.searchFilterField.value);
    this.resetFilter();
    this.ajaxReload();
  }

  changeFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue(this.searchFilterForm.controls.searchOldValue.value);
    this.resetFilter();
    this.trigger();
  }

  changeLengthPage(length) {
    let firstPage = 0;
    this.changeLength(length.value, firstPage);
    this.dtOptions.pageLength = this.dimPagina;
    this.trigger();
  }

  removeLength() {
    let firstPage = 0;
    let length = 10;
    this.selectedMenu.push({ 'value': 10 });
    this.changeLength(length, firstPage);
    this.dtOptions.pageLength = this.dimPagina;
    this.resetFilter();
    this.trigger();
  }


  /**
   * Prende i filtri
   * @returns 
   */
  getFilter() {
    let storeRequestSearch = new StoreRequestSearch();
    storeRequestSearch.q = this.searchFilterForm.controls['searchFilterField'].value;
    storeRequestSearch.pageNumber = this.numeroPagina;
    storeRequestSearch.pageSize = this.dimPagina;

    if (this.searchFilterOther.searchFilterField_dealerCategory.length > 0) {
      storeRequestSearch.dealerCategory = this.searchFilterOther.searchFilterField_dealerCategory[0].value;
    }
    if (this.searchFilterOther.searchFilterField_productServiceIds.length > 0) {
      storeRequestSearch.productServiceIds = this.searchFilterOther.searchFilterField_productServiceIds;
    }

    storeRequestSearch.visibilityClickAndCollectSim = true;
    return storeRequestSearch;
  }

  clickButtonUpdate(id) {
    const url = 'store/store/' + id;
    this.router.navigate([url], { queryParams: { history: true }, queryParamsHandling: 'preserve' });
  }


  clickButtonClearFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue('');
    this.clickSearch();
  }

  //Autocomplete - productAndServices  <- Prodotti e Servizi
  @ViewChild('productAndServices ') productAndServices;
  productAndServices_Keyword = 'serviceName';
  productAndServices_Suggestion: any = [];
  productAndServices_Selected: any = [];
  productAndServices_errorMsg: string;
  productAndServices_isKeywordLoadingResult: boolean;

  getFilter_productAndServices(event) {
    let request = new ProductServiceRequestSearch();
    request.serviceName = event;
    request.published = true;
    request.pageNumber = 0
    request.pageSize = 20
    return request
  }
  fill_productAndServices_Suggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.productAndServices_Selected.length && !trovato; j++) {
        if (obj.id == this.productAndServices_Selected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.productAndServices_Suggestion.push(obj);
      }
    }
  }
  getList_productAndServices(event) {
    this.productAndServices_isKeywordLoadingResult = true;
    let request = this.getFilter_productAndServices(event);
    this.productServiceService.search(request).subscribe(response => {
      this.productAndServices_Suggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_productAndServices_Suggestion(response);
      }
      this.productAndServices_isKeywordLoadingResult = false;
    });
  }
  searchCleared__productAndServices() {
    this.productAndServices_Suggestion = [];
  }
  selectEvent__productAndServices(item) {
    this.productAndServices_Selected.push(item);
    this.searchFilterOther.searchFilterField_productServiceIds.push(item.id);
    this.productAndServices.clear();
    this.changeFilter();
  }
  onFocused__productAndServices(e) {
    console.log(e);
    this.getList_productAndServices("");
    // do something when input is focused
  }
  //Chip list - productAndServices <- Prodotti e Servizi
  labelKeys_productAndServices = ["serviceName"];
  onChangeItemList_productAndServices(evt) {
    console.log(evt);
    this.searchFilterOther.searchFilterField_productServiceIds = [];
    for (let e of evt) {
      this.searchFilterOther.searchFilterField_productServiceIds.push(e.id);
    }
    this.changeFilter();
  }

  /* FUNZIONI PER MODIFICHE DI MASSA */
  titleFlag: string = "Flags"
  public massModifyItemsFlags: MassModifyItem[] = [
    {
      id: 'visibilityClickAndCollectSim',
      title: 'Visibilità C&C SIM', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'No', icon: '', styleClass: '', value: 'visibilityClickAndCollectSim_FALSE', }
      ]
    }
  ];

  choiceButtonMassModifyResponse(value) {
    let isOk = this.onClickControllItemMassModify();
    if (isOk === TRUE) {
      let flagName = "";
      switch (value) {
        //Flags
        case 'visibilityClickAndCollectSim_TRUE':
        case 'visibilityClickAndCollectSmartphone_TRUE':
        case 'visibilityEmail_TRUE':
        case 'visibilityEvent_TRUE':
        case 'visibilityFacebook_TRUE':
        case 'visibilityFullStoreDescription_TRUE':
        case 'visibilityGallery_TRUE':
        case 'visibilityGooglePlace_TRUE':
        case 'visibilityInternalGallery_TRUE':
        case 'visibilityManageOpeningClosingTime_TRUE':
        case 'visibilityManageOpeningClosingTimeAppointments_TRUE':
        case 'visibilityOpeningClosingTime_TRUE':
        case 'visibilityPromotion_TRUE':
        case 'visibilityScheduleAppointments_TRUE':
        case 'visibilityServices_TRUE':
        case 'visibilityStoreManager_TRUE':
        case 'visibilityStoreManagerEmail_TRUE':
        case 'visibilityStoreManagerPhoto_TRUE':
        case 'visibilityStoreManagerTelephone_TRUE':
        case 'visibilityTelephone_TRUE':
          flagName = value.split("_")[0];
          this.onClickButtonItemMassModify_flags(flagName, true);
          break;

        case 'visibilityClickAndCollectSim_FALSE':
        case 'visibilityClickAndCollectSmartphone_FALSE':
        case 'visibilityEmail_FALSE':
        case 'visibilityEvent_FALSE':
        case 'visibilityFacebook_FALSE':
        case 'visibilityFullStoreDescription_FALSE':
        case 'visibilityGallery_FALSE':
        case 'visibilityGooglePlace_FALSE':
        case 'visibilityInternalGallery_FALSE':
        case 'visibilityManageOpeningClosingTime_FALSE':
        case 'visibilityManageOpeningClosingTimeAppointments_FALSE':
        case 'visibilityOpeningClosingTime_FALSE':
        case 'visibilityPromotion_FALSE':
        case 'visibilityScheduleAppointments_FALSE':
        case 'visibilityServices_FALSE':
        case 'visibilityStoreManager_FALSE':
        case 'visibilityStoreManagerEmail':
        case 'visibilityStoreManagerPhoto_FALSE':
        case 'visibilityStoreManagerTelephone_FALSE':
        case 'visibilityTelephone_FALSE':
          flagName = value.split("_")[0];
          this.onClickButtonItemMassModify_flags(flagName, false);
          break;
      }
    }
  }

  getLabelFlag(value) {
    let res = "";
    for (let obj of this.massModifyItemsFlags) {
      if (obj.id === value) {
        res = obj.title;
      }
    }
    return res;
  }

  onClickButtonItemMassModify_flags(flag, value) {
    console.log(flag + " = " + value);
    let list = this.getListChecked();
    let request = {
      flags: {},
      storeIds: []
    }
    let storeIds = [];
    let massModifyObj = [];
    if (list.length > 0) {

      request.flags[flag] = value;
      for (let obj of list) {
        storeIds.push(obj.id);
      }
      request['storeIds'] = storeIds;

      let valueTitle = value ? 'Si' : 'No';
      let flagTitle = this.getLabelFlag(flag);
      let title = 'Caricamento massivo del flag ' + flagTitle + ' settato a ' + valueTitle;

      massModifyObj.push({
        id: 0,
        title: title,
        loading: true,
        call: () => {
          return this.storeService.updateMassiveFlag(request)
        }
      });
      this.openMultiLoadingView(massModifyObj);
    }
  }



}
